import { useTranslation } from 'react-i18next';
import { CardMaker } from '@karma/components';
import { LeafIcon, RefurbishedIcon } from '@karma/components/icons';

const TAG_CONDITIONS = {
  NEW: 0,
  USED: 1,
  REFURBISHED: 2,
  DAMAGED: 3,
};

const ItemConditionMarker = ({ itemCondition }) => {
  const { t } = useTranslation();

  if (itemCondition === TAG_CONDITIONS.USED || itemCondition === TAG_CONDITIONS.DAMAGED) {
    return (
      <CardMaker Icon={LeafIcon} color="shades8">
        {t('app:preOwned')}
      </CardMaker>
    );
  }

  if (itemCondition === TAG_CONDITIONS.REFURBISHED) {
    return (
      <CardMaker Icon={RefurbishedIcon} color="shades8">
        {t('app:refurbished')}
      </CardMaker>
    );
  }

  return null;
};

export default ItemConditionMarker;
